import React from 'react';
import AnchoredSections, { AnchoredItem } from '../../adminComponents/AdminSection/AnchoredSections';
import { Locale } from '../../../../../localization/LocalizationKeys';
import { useLocalization } from '../../../../util/useLocalization';
import ConfigureTableColumnSettings from '../../../../components/ConfigureTableColumnSettings/ConfigureTableColumnSettings';
import {
  TableColumnConfigureSettingType
} from '../../../../components/ConfigureTableColumnSettings/useTableColumnConfigureSettings';
import AdminConfigureSearch from '../../adminComponents/AdminConfigureSearch/AdminConfigureSearch';
import { EntityTypeEnum } from '../../../../../gql/typings';

const DcrAdminSettings: React.FC = () => {
  const localization = useLocalization();
  return (
    <div className="dcr-admin-settings-container">
      <AnchoredSections>

        <AnchoredItem anchor="search" title={localization.formatMessage(Locale.Command.Search)}>
          <AdminConfigureSearch entityType={EntityTypeEnum.DCR_GROUP} />
        </AnchoredItem>

        <AnchoredItem anchor="table-columns" title={localization.formatMessage(Locale.General.Table_columns)}>
          <ConfigureTableColumnSettings
            entityType={EntityTypeEnum.DCR_GROUP}
            type={TableColumnConfigureSettingType.SYSTEM}
          />
        </AnchoredItem>

      </AnchoredSections>
    </div>
  );
};

export default DcrAdminSettings;
